// extracted by mini-css-extract-plugin
export default {"root":"FormBox_root__ZQbgh","errorBox":"FormBox_errorBox__QKrPg","formBox_theme":"FormBox_formBox_theme__BtTVU"};